import { render, staticRenderFns } from "./ImportProductOrderForm.vue?vue&type=template&id=3c3819ea&scoped=true"
import script from "./ImportProductOrderForm.vue?vue&type=script&lang=ts"
export * from "./ImportProductOrderForm.vue?vue&type=script&lang=ts"
import style0 from "./ImportProductOrderForm.vue?vue&type=style&index=0&id=3c3819ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3819ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3819ea')) {
      api.createRecord('3c3819ea', component.options)
    } else {
      api.reload('3c3819ea', component.options)
    }
    module.hot.accept("./ImportProductOrderForm.vue?vue&type=template&id=3c3819ea&scoped=true", function () {
      api.rerender('3c3819ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/components/ImportProductOrderForm.vue"
export default component.exports